import { z } from "zod";

import { phoneNumberSchema } from "@/shared/utils/phone-utils";

export enum IntakeSmsAction {
  Prepare = "prepare",
  Send = "send",
}

export enum IntakeSmsResultStatus {
  Queued = "queued",
  Ready = "ready",
  Sent = "sent",
  Unavailable = "unavailable",
  Unknown = "unknown",
}

export enum IntakeSmsUnavailableReason {
  ActiveConversation = "active_conversation",
  MissingPhone = "missing_phone",
  OptedOut = "opted_out",
  PhoneChanged = "phone_changed",
  SendFailed = "send_failed",
  Unsupported = "unsupported",
}

const requestContext = z.object({
  groupId: z.string().uuid(),
  patientId: z.string().uuid(),
  requestId: z.string().min(1).max(200),
});

export const intakeSmsConsentSchema = z.object({
  consent: z.literal(true),
  phoneNumber: phoneNumberSchema,
});

export const intakeSmsRequestSchema = z.discriminatedUnion("action", [
  requestContext.extend({ action: z.literal(IntakeSmsAction.Prepare) }),
  requestContext.extend({
    action: z.literal(IntakeSmsAction.Send),
    ...intakeSmsConsentSchema.shape,
  }),
]);

export const intakeSmsResponseSchema = z.discriminatedUnion("status", [
  z.object({
    status: z.literal(IntakeSmsResultStatus.Ready),
    phoneNumber: phoneNumberSchema,
    bookingHandoffSupported: z.literal(true).optional(),
  }),
  z.object({ status: z.literal(IntakeSmsResultStatus.Queued) }),
  z.object({ status: z.literal(IntakeSmsResultStatus.Unknown) }),
  z.object({ status: z.literal(IntakeSmsResultStatus.Sent), messageId: z.string().uuid() }),
  z.object({
    status: z.literal(IntakeSmsResultStatus.Unavailable),
    reason: z.enum(IntakeSmsUnavailableReason),
  }),
]);

export type IntakeSmsRequest = z.infer<typeof intakeSmsRequestSchema>;
export type IntakeSmsResponse = z.infer<typeof intakeSmsResponseSchema>;
